// extracted by mini-css-extract-plugin
export var root = "ArticleMeta-root-26pIC";
export var rootDate = "ArticleMeta-root_date-hYuSI";
export var rootReadingTime = "ArticleMeta-root_readingTime-S9quF";
export var rootReadingTimeIcon = "ArticleMeta-root_readingTimeIcon-4dJqd";
export var rootReadingTimeWrapper = "ArticleMeta-root_readingTimeWrapper-JlZHN";